import { css } from '@emotion/react';

import { ReactNode } from 'react';

import { FontSizes, Sizes, Spacing } from 'chatie-design-system';

import { CSSProps } from '../../utils/misc';

const listCSS = (fontSize: number, margin: number) =>
  css`
    list-style-type: none;
    font-size: ${fontSize}px;
    padding-left: ${Spacing.medium}px;

    li + li {
      margin-top: ${margin}px;
    }

    li {
      position: relative;

      p {
        word-break: keep-all;
      }

      &:before {
        content: '·';
        position: absolute;
        top: -1px;
        left: -12px;
      }
    }
  `;

type Props = {
  items: (string | ReactNode)[];
  size?: Sizes.small | Sizes.medium;
};

const DottedListSize = {
  [Sizes.small]: {
    fontSize: FontSizes.xsmall,
    margin: Spacing.xxsmall,
  },
  [Sizes.medium]: {
    fontSize: FontSizes.small,
    margin: Spacing.xhsmall,
  },
};

const DottedList = ({
  className,
  items,
  size = Sizes.medium,
}: Props & CSSProps) => {
  const { fontSize, margin } = DottedListSize[size];

  return (
    <ul css={listCSS(fontSize, margin)} className={className}>
      {items.map((item, i) => (
        <li key={`dotted-list-${i}`}>
          <div className="dot" />
          {typeof item === 'string' ? (
            <p className="multiline">{item}</p>
          ) : (
            item
          )}
        </li>
      ))}
    </ul>
  );
};

export default DottedList;
